import React from "react";

import UnderlinedIcon from "@mui/icons-material/FormatUnderlined";

import { ToggleButton } from "@/uiKit/atoms/ToggleButton.tsx";
import {
  RichTextToggleButtonsProps,
  toggleButtonStyles,
} from "@/uiKit/molecules/RichText/inputs/RichTextInputTypes.ts";

export const UnderlinedToggleButton: React.FC<RichTextToggleButtonsProps> = props => (
  <ToggleButton data-action="common.rich-text.toggle-underline" value="underlined" aria-label="underlined" {...props}>
    <UnderlinedIcon className={toggleButtonStyles.icon} />
  </ToggleButton>
);
